import React from "react";
import { useDrop } from "react-dnd";

import { Stem } from "@examspark/types";

import { useDrag } from "../../hooks/useDnd";
import { DndItem } from "../shared/Token";

type MatchCellProps = {
  accept: string[];
  content?: Stem.Option;
  onDrop: (item: DndItem) => void;
  onLeave: (item: DndItem) => void;
  children?: React.ReactNode;
};

type CollectedProps = {
  canDrop: boolean;
  isOver: boolean;
  item: DndItem;
  dropResult: any;
};
const MatchCell = (props: MatchCellProps) => {
  const [collectedProps, drop] = useDrop<DndItem, void, CollectedProps>({
    accept: props.accept,
    drop: (item) => {
      props.onDrop(item);
    },
    collect: (monitor) => {
      return {
        canDrop: monitor.canDrop(),
        isOver: monitor.isOver(),
        item: monitor.getItem(),
        dropResult: monitor.getDropResult(),
      };
    },
  });

  const dragRef = React.useRef(null);
  useDrag(dragRef, {
    item: {
      type: "token",
      id: props.content ? props.content.id : null,
    },
    end: (item, monitor) => {
      // Typescript wasn't taking advantage of the item.id type guard so I
      // manually cast it
      if (!monitor.didDrop() && item?.id) {
        props.onLeave(item as DndItem);
      }
    },
  });

  const classes = ["item-player-match-cell"];
  if (collectedProps.isOver) {
    classes.push("is-over");
  }

  return (
    <div className={classes.join(" ")} ref={drop}>
      {props.children && <div ref={dragRef}>{props.children}</div>}
    </div>
  );
};

export default MatchCell;
